import { createSlice } from "@reduxjs/toolkit";
import {
  getTeacherAssessmentThunk,
  getcategoryThunk,
  updateTeacherAssessmentThunk,
  createTeacherAssessmentThunk,
  deleteTeacherAssessmentThunk,
} from "./TeacherBaseline.Thunk";

const initialState = {
  data: [],
  category: [],
  loading: false,
  status: "",
  message: "",
  preferedlanguage: "",
  usertype: "",
  type: "",
  categoryId: "",
  categoryName: "",
  disable_content_button: true,
};

const TeacherBaselineSlice = createSlice({
  name: "teacherbaselineslice",
  initialState,
  reducers: {
    preferedlanguage_change: (state, action) => {
      state.preferedlanguage = action.payload;
      state.data = [];
      state.disable_content_button = true;
    },
    usertype_change: (state, action) => {
      state.usertype = action.payload;
      state.data = [];
      state.disable_content_button = true;
    },
    category_change: (state, action) => {
      state.categoryId = action.payload;
      state.categoryName = action.payload;
      state.data = [];
      state.disable_content_button = false;
    },
    assessment_change: (state, action) => {
      state.type = action.payload;
      state.data = [];
      state.disable_content_button = false;
    },
  },
  extraReducers: {
    [getTeacherAssessmentThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getTeacherAssessmentThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getTeacherAssessmentThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },

    [getcategoryThunk.pending]: (state, action) => {
      state.category = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getcategoryThunk.fulfilled]: (state, action) => {
      state.category = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getcategoryThunk.rejected]: (state, action) => {
      state.category = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [createTeacherAssessmentThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [createTeacherAssessmentThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [createTeacherAssessmentThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },

    [updateTeacherAssessmentThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [updateTeacherAssessmentThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [updateTeacherAssessmentThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
  },
});

export const {
  preferedlanguage_change,
  usertype_change,
  category_change,
  assessment_change,
} = TeacherBaselineSlice.actions;

export default TeacherBaselineSlice.reducer;
